var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import { Button, Icon, Input } from 'elements';
class SearchInput extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: ''
        };
        this.handleChange = (value) => {
            this.setState({ value });
            this.props.onChange(value);
        };
    }
    render() {
        const _a = this.props, { onChange } = _a, props = __rest(_a, ["onChange"]);
        const { value } = this.state;
        return (React.createElement(Wrapper, Object.assign({}, props),
            React.createElement(Icon, { name: "search" }),
            React.createElement(StyledInput, { type: "text", value: value, onChange: event => this.handleChange(event.target.value), underline: false }),
            React.createElement(Button, { onClick: () => this.handleChange('') },
                React.createElement(Icon, { name: "del" }))));
    }
}
export default SearchInput;
const Wrapper = cxs('div')({
    display: 'flex'
});
const StyledInput = cxs(Input)({
    flex: 1
});



//////////////////
// WEBPACK FOOTER
// ./src/components/SearchInput.tsx
// module id = 547
// module chunks = 0